export default __webpack_public_path__ + "static/media/10_briefcase 2.d98d98bd.gif";